import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

type ModalContainerProps = {
  rootId: string;
};

/**
 * A thin wrapper that creates a portal given a specific root id.
 */
const ModalContainer: React.FC<ModalContainerProps> = ({ children, rootId }) => {
  const el = useRef(document.createElement('div'));
  useEffect(() => {
    const { current } = el;
    const modalRoot = document.getElementById(rootId);

    if (modalRoot) modalRoot.appendChild(current);
    return () => {
      if (modalRoot) modalRoot.removeChild(current);
    };
  }, [rootId]);

  return createPortal(children, el.current);
};

export default ModalContainer;
